import { ServiceLocator } from '../../../app/ServiceLocator';
import { SpaceInfo } from '../../../app/state/SpaceInfo';
import { SupportedContentTypes } from '../../../home/types/HomeTypes';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { TelemetryService } from '../../../ts/services/TelemetryService';
import { ContentTelemetryEvents, TelemetryEvents } from '../TelemetryEvents';
import {
  ActionMenuItemClickedEvent,
  ContentClickedEvent,
  ContentLocation,
  ContentTelemetryCommonData,
  ContentTelemetryContextSpecificData,
  FavoriteToggleClickedEvent,
  FavoriteToggleType,
} from '../types/ContentTelemetryTypes';

export function generateTelemetryEventHandler(
  type: ContentTelemetryEvents,
  spaceInfo: SpaceInfo,
  allContents: ReadonlyArray<SupportedContentTypes>,
  contentInfo: IContentInfo,
  contentLocation: ContentLocation,
  contentPosition: number,
  specificData: ContentTelemetryContextSpecificData): (...args: any[]) => void {
  const telemetryService: TelemetryService = ServiceLocator.get<TelemetryService>('TelemetryService');
  const commonData: ContentTelemetryCommonData = {
    contentId: contentInfo.id,
    contentType: contentInfo.contentType,
    contentLocation: contentLocation,
    space: spaceInfo.spaceType,
    subspace: spaceInfo.subspaceName,
    contentPosition: contentPosition,
  };

  // if the content is a recommendation, add meta data to telemetry event
  if (commonData.contentType && commonData.contentType === 'recommendedView') {
    specificData = {
      ...specificData,
      recommendationsMetadata: JSON.stringify({
        modelId: contentInfo.modelId,
        seenViews: allContents.slice(0, contentPosition).map(x => parseInt(x.id, 10))
      })
    };
  }

  switch (type) {
    case TelemetryEvents.ContentClicked: {
      return function onContentClick() {
        telemetryService.sendEvent<ContentClickedEvent>(
          { ...commonData, ...specificData, type: TelemetryEvents.ContentClicked }
        );
      };
    }
    case TelemetryEvents.FavoriteToggleClicked: {
      return function onFavoriteToggleClick(toggleType: FavoriteToggleType) {
        telemetryService.sendEvent<FavoriteToggleClickedEvent>(
          { ...commonData, ...specificData, type: TelemetryEvents.FavoriteToggleClicked, toggleType }
        );
      };
    }
    case TelemetryEvents.ActionMenuItemClicked: {
      return function onActionMenuItemClick(actionType: string) {
        telemetryService.sendEvent<ActionMenuItemClickedEvent>(
          { ...commonData, ...specificData, type: TelemetryEvents.ActionMenuItemClicked, actionType }
        );
      };
    }
  }
}
